export default __webpack_public_path__ + "0c39a39d5edf7b1fb4617a6a50911488.png";